import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, Responsive } from '@cian/ui-kit';
import * as styles from './Section.css';

interface ISectionProps extends React.PropsWithChildren {
  'data-name'?: string;
  'data-testid'?: string;
  title?: string;
}

export const Section: React.FC<ISectionProps> = ({ children, title, ...props }) => {
  return (
    <section {...props}>
      {title && (
        <div className={styles['section-title']} data-testid="SectionHeader">
          <Responsive desktop>
            <ArticleHeading1 as="h2">{title}</ArticleHeading1>
          </Responsive>
          <Responsive tablet phone>
            <ArticleHeading2 as="h2">{title}</ArticleHeading2>
          </Responsive>
        </div>
      )}
      {children}
    </section>
  );
};
